module.exports = __webpack_public_path__ + "img/tb-07@2x.1532fbfc.png";